import * as React from 'react'

import {
  GlobalDrawer,
  NavigationManager,
  Sidebar,
}                        from '../../routing'
import { Routing }       from '../../types'
import { AppBarSpacing } from '../atoms'
import { AppBar }        from '../molecules'
import { AppTemplate }   from '../templates'

const {
  Root,
  Main,
} = AppTemplate

interface AppProps { routing: Routing }
interface State { isGlobalDrawerOpen: boolean }

export default class extends React.Component<AppProps, State> {
  public state = {
    isGlobalDrawerOpen: false,
  }

  public render () {
    const { routing } = this.props
    const { isGlobalDrawerOpen } = this.state

    return (
      <Root>
        <AppBar onMenuClick={this.openGlobalDrawer} />
        <GlobalDrawer
          routing={routing}
          isOpen={isGlobalDrawerOpen}
          onClose={this.closeGlobalDrawer}
        />
        <Sidebar routing={routing} />
        <Main>
          <AppBarSpacing />
          <NavigationManager routing={routing} />
        </Main>
      </Root>
    )
  }

  private closeGlobalDrawer = () => {
    this.setState({ isGlobalDrawerOpen: false })
  }

  private openGlobalDrawer = () => {
    this.setState({ isGlobalDrawerOpen: true })
  }
}



// WEBPACK FOOTER //
// ./src/components/environments/App.tsx